module.exports = __webpack_public_path__ + "img/battery-equipment.c87fbf61.png";